import { IStyle, mergeStyleSets } from "@fluentui/react"; 
import { ThemeMode, getThemeColors } from "./contexts/ThemeContext";

export const getAppStyles = (isNavCollapsed: boolean, themeMode: ThemeMode = "light", isStandalone: boolean = false) => {
  const colors = getThemeColors(themeMode);
  return mergeStyleSets({
    root: { 
      backgroundColor: colors.bg,
      color: colors.fg,
    } as IStyle,

    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      marginLeft: isStandalone ? 0 : (isNavCollapsed ? 68 : 228),
      transition: 'margin-left 0.3s',
    } as IStyle,

    mainContainer: {
      flex: '1 0 auto',
      paddingLeft: 10,
      paddingRight: 10,
      paddingBottom: 10,
    } as IStyle,

    footerStyle: {
      flexShrink: 0,
      padding: 10,
      backgroundColor: colors.footerBg,
      borderTop: `1px solid ${colors.footerBorder}`,
      boxSizing: 'border-box',
    } as IStyle,

    stickyHeader:{
      position: 'sticky',
      top: '0',
      width: '100%',
      zIndex: '100'
    }
  });
};